export default __webpack_public_path__ + "static/media/icon_tabs_education_active.8ebe1b49.svg";